import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@glu/dropdown-react';
import { createUseStyles } from '@glu/theming';
import get from 'lodash/get';
import LocaleContext from '../../locale/LocaleContext';

import { PAYMENT_TYPES } from '../../../constants';
import { getCalculations } from './PaymentInfo';
import WireContext from '../WireContext';

const styles = () => ({
  charges: {
    '& > label, & div[data-qa=dropdown-position]': {
      width: '100%'
    }
  }
});

const useStyles = createUseStyles(styles);

const CurrencyComponent = ({
  data,
  formChange,
  formState,
  fromTemplate,
  onParentUpdate,
  state
}) => {
  const locale = useContext(LocaleContext);
  const classes = useStyles();
  const wireContextState = useContext(WireContext);

  const domestic = get(state, '0.type', get(state, 'paymentType')) === PAYMENT_TYPES.WIRE.DOMESTIC;
  const defValue = data.fxRates.find(
    (x) =>
      x.id ===
      (get(formState, 'currency.0.id') || get(state, 'currency.0.id') || formState.currency)
  );
  const fallback = {
    id: 1,
    name: 'USD - United States Dollar',
    currency: 'USD',
    currencyName: 'United States Dollar'
  };

  if (domestic) {
    return null;
  }

  const props = {
    key: 'currency',
    name: 'currency',
    id: 'currency',
    dataQa: 'currency',
    htmlId: 'currency',
    labelText: 'Currency',
    defaultValue: defValue ? [defValue] : [fallback],
    options: data.fxRates,
    validators: [{ required: true, msg: locale['validation.required'] }],
    placeholder: locale['common.select'],
    className: classes.charges,
    format: () => get(formState, 'currency.0.name'),
    onBlur: () => {
      // Set default exchange rate when user clicks on a currency
      // Set timeout is needed to make sure state has been updated
      setTimeout(() => {
        const currency = wireContextState.getCurrency();
        formChange('exchangeRate', get(currency, '[0].exchange'));
      }, 500);
    },
    onChange: (_, value) => {
      const exchange = get(value, '0.exchange');
      const instance = get(value, '0');

      if (!value.length) return;

      const details = getCalculations(
        {
          ...formState,
          exchangeRate: exchange,
          currency: instance.currency
        },
        data
      );
      const { type } = details;
      const isUSD = get(value, '[0].currency') === 'USD';

      formChange('isUSD', isUSD);
      formChange('currencyPrefix', get(value, '[0].currency'));
      if (wireContextState && wireContextState.updateData) {
        wireContextState.updateData({ currency: value });
      }
      onParentUpdate(details[type].sent, instance);
    },
    disabled: fromTemplate
  };

  return (
    <div className="col-xs-2">
      <Dropdown {...props} />
    </div>
  );
};

CurrencyComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  formChange: PropTypes.func.isRequired,
  onParentUpdate: PropTypes.func.isRequired,
  formState: PropTypes.shape({}).isRequired,
  state: PropTypes.shape({}).isRequired,
  fromTemplate: PropTypes.bool.isRequired
};

export default CurrencyComponent;
